import React from "react";
import { noop } from "lib/utils";
import "styles/components/radio-button.scss";

const RadioButton = ({ label, ariaLabel, subTitle, name, onChange = noop, selected, value, ...props }) => {
  const onInputChange = e => {
    onChange(e.target.value);
  };

  if (ariaLabel === undefined && typeof label === "string") {
    ariaLabel = label;
  }
  return (
    <label className="otrl-jp__radio-button" aria-label={ariaLabel}>
      <span aria-hidden>{label}</span>
      {subTitle &&
        <span className="otrl-jp__radio-button__sub-title">
          {subTitle}
        </span>
      }
      <input
        className="otrl-jp__radio-button__input"
        checked={selected === value}
        type="radio"
        name={name}
        onChange={onInputChange}
        value={value}
        {...props}
      />
      <span className="otrl-jp__radio-button__checkmark"></span>
    </label>
  );
};

export default RadioButton;
